import React from 'react';

const CloseModalSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19"><polygon points="9.5 11.6 3.1 18 0.6 15.5 6.7 9.4 0.6 3.2 3.1 0.8 9.5 7.2 15.9 0.8 18.4 3.2 12.2 9.4 18.4 15.5 15.9 18 9.5 11.6" fill="#FFF"/></svg>
);

export default CloseModalSvg;
